import logo from '@/assets/Vdoit-logo.png';
import { DesktopMenu } from './DesktopMenu';

export const LeftNav = () => {
  return (
    <div className="flex items-center justify-between gap-2 lg:gap-8 h-full">
      <img src={logo} alt="logo" className="max-w-20 ml-1" />
      <DesktopMenu />
    </div>
  );
};
